import { render } from "./Acceptability.vue?vue&type=template&id=6b9694c8"
import script from "./Acceptability.vue?vue&type=script&lang=js"
export * from "./Acceptability.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__